export enum InputButtonType {
  NO_BTN = 1,
  SEARCH_BTN
}
